/**
 * Side menu component
 * Displays an avatar with the user name
 */
import React from "react"
import { Wrapper, TitleContainer, ButtonContainer } from "./styles"
import Button from "components/Button"
import SelectField from "components/SelectField"
import { goToLanguageSite } from "utils/languageUtils"

export class PreviewModeBanner extends React.Component {
  exit = () => {
    this.props.logout()
  }

  render() {
    const { languageList, query } = this.props
    const { language } = query
    return (
      <Wrapper>
        <ButtonContainer>&nbsp;</ButtonContainer>
        <TitleContainer>Preview mode</TitleContainer>
        {languageList && (
          <SelectField
            size={"mediumLarge"}
            id={`language`}
            options={languageList}
            onChange={(id, value) => {
              goToLanguageSite(value)
            }}
            getOptionLabel={({ value }) => value}
            value={languageList.find(x => x.id === (language || ""))}
          />
        )}
        <ButtonContainer>
          <Button
            label={"Exit"}
            verySmall
            inherit
            name={"applications"}
            onClick={this.exit}
            width={"150px"}
          />
        </ButtonContainer>
      </Wrapper>
    )
  }
}

export default PreviewModeBanner
